import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { clearCart } from "../../redux/cart/CartSlice";
import { Baseurl } from "../../config/BaseUrl";
import { updateOrder } from "../../redux/order/OrderSlice";

const OrderSuccesProducts = () => {
  const { currentOrder } = useSelector((state) => state.Order);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  console.log(currentOrder, "PaymentMode");

  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (currentOrder.PaymentMode === "CashOnDelivery") {
      navigate("/payment-success");
    } else {
      const payTmPayHandleSubmit = async (e) => {
        try {
          const orderId = currentOrder._id;
          if (!orderId) {
            setStatus("Order ID not found!");
            setLoading(false);
            return;
          }
          const response = await fetch(
            `${Baseurl}/api/v1/order/get_payment_status`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ _id: orderId }),
            }
          );
          const data = await response.json();
          console.log("Payment Status Response:", data);

          if (!data.success) {
            setStatus("Failed to fetch payment status");
            setLoading(false);
            return;
          }

          let orderInfo = data.order;
          const paymentResponse = data.orderStatus;
          const transactionId = paymentResponse?.TxnId;

          if (paymentResponse.ResponseCode === "00") {
            orderInfo = {
              ...orderInfo,
              orderid: orderInfo._id,
              PaymentStatus: "Paid",
              PaymentMode: "Online",
              TxnId: transactionId,
              CurrentStatus: "Order Confirmed",
            };
            console.log("1");

            setStatus("Payment Successful! Updating Order...");
            navigate("/payment-success");
          } else if (paymentResponse.ResponseCode === "01") {
            orderInfo = {
              ...orderInfo,
              orderid: orderInfo._id,
              PaymentStatus: "Pending",
              PaymentMode: "Online",
              TxnId: transactionId,
              CurrentStatus: "Payment Pending",
            };
            console.log("2");

            setStatus("Payment Pending. We will update your order soon.");
            navigate("/payment-pending");
          } else {
            orderInfo = {
              ...orderInfo,
              orderid: orderInfo._id,
            };
            console.log("3");
            setStatus("Payment Failed. Switching to Cash on Delivery (COD)...");
            navigate("/payment-failed");
          }
          dispatch(updateOrder(orderInfo));
        } catch (error) {
          console.error("Error:", error);
        }
      };
      payTmPayHandleSubmit();
    }
  }, [currentOrder]);

  useEffect(() => {
    if (currentOrder !== "") {
      dispatch(clearCart());
    }
  }, [currentOrder]);

  return (
    <>
      <div className="col-xxl-9 col-lg-8">
        <div className="cart-table order-table order-table-2">
          <div className="table-responsive">
            <table className="table mb-0">
              <tbody>
                <td>Redirecting...</td>
                {/* {currentOrder.OrderProducts.map((order, index) => (
                  <tr key={index}>
                    <td className="product-detail">
                      <div className="product border-0">
                        <a
                          href="product.left-sidebar.html"
                          className="product-image"
                        >
                          <img
                            src={order.ImgUrl}
                            className="img-fluid blur-up lazyload"
                            alt
                          />
                        </a>
                        <div
                          className="product-detail"
                          style={{ width: "200px" }}
                        >
                          <ul>
                            <li className="name">
                              <a href="product-left-thumbnail.html">
                                {order.ItemName}
                              </a>
                            </li>
                            <li className="text-content">
                              Sold By: {order.Brand}
                            </li>
                            <li className="text-content">
                              Quantity - {order.PackSize}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </td>
                    <td className="price">
                      <h4 className="table-title text-content">Price</h4>
                      <h6 className="theme-color">₹ {order.Price}</h6>
                    </td>
                    <td className="quantity">
                      <h4 className="table-title text-content">Qty</h4>
                      <h4 className="text-title"> {order.Qty}</h4>
                    </td>
                    <td className="subtotal">
                      <h4 className="table-title text-content">Total</h4>
                      <h5>₹ {order.TotalPrice}</h5>
                    </td>
                  </tr>
                ))} */}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderSuccesProducts;
